import React from "react";
import "./Projects.css";
import { DiCss3, DiMongodb} from "react-icons/di";
import { FaReact} from "react-icons/fa";
import {
  SiHtml5,
  SiJavascript,
  SiChakraui,
  SiRedux, 
   
} from "react-icons/si";




export const Projects = () => {
  return (
    <>
      <div className="section">

      <br />
      <br />
      <br />
      <br />
      
        <h2 className="section__title different">Projects 📄</h2>
        {/* <p className="section__title different">recently worked on:-</p> */}
        <div className="allProjects">

{/* 1st */}

<div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="http://markjames.ca/wp-content/uploads/2021/09/Nord_MensYC_TrendReport_DesktopMock-1280x720.png"
                    alt="Uniqlo-Clone"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Nord Strom Clone </h2>
                <p>"Nord Strom" is an online shopping website, which mainly focused on shoes, accessories handbags, home accents, and other accessories for women, men, young adults, and children.</p>

                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <SiJavascript/>
                  <FaReact/>
                  <SiChakraui/>
                </div>

                <div>
                  <a
                    href="https://nordstrom-one.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/Jhakailash/defiant-existence-329"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>


          {/* 2nd */}


          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://user-images.githubusercontent.com/100188131/171994687-bf5d91b3-c63f-44b8-98b1-b486100a34d8.png"
                    alt="Uniqlo-Clone"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Bobbi Brown Clone</h2>
                <p>"Bobbi Brown" Cosmetics is a beauty brand that empowers women to embrace and enhance their beauty. It's an e-commerce website, which mainly focused on "Makeup" related products.</p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <SiJavascript/>
                                    
                </div>
                <div>
                  <a
                    href="https://lucid-kilby-2ad2ec.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/Jhakailash/Bobbi_Brown_Cosmetics?organization=Jhakailash&organization=Jhakailash"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>


          {/* 3rd */}

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://user-images.githubusercontent.com/101565730/201592601-da7ad561-199c-4449-9622-489d7ed02791.png"
                    alt="kfc-india-Clone"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Groc Store Clone</h2>
                <p>"Groc Store" is a clone of the big basket, one of India's largest online grocery supermarkets. Where users can buy Fruits & Vegetables online. It was founded in 2011 and has headquarters in Bengaluru.</p>
                <div>
                  <SiHtml5/>
                  <DiCss3/>
                  <SiJavascript/>
                  <SiRedux />
                  <SiChakraui/>
                  <FaReact/>
                  
                </div>
                <div>
                  <a
                    href="https://groc-basket-jhakailash.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/Jhakailash/Groc-Store"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          
          {/* 4th */}


          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://camo.githubusercontent.com/1957f9f6a788be580f3947203cc34bc680441b30b2ea4802040e2c31e2c4ff1a/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313430302f312a617675306b4959786854303578543770785734444d512e676966"
                    alt="Uniqlo-Clone"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Everhour Clone</h2>
                <p>"Everhour" is powerful time-tracking software with hassle-free integrations. With Everhour's time clock app, you can use almost any device that connects to the internet to monitor your team's time.</p>
                <div>
                  <SiHtml5/>
                  <DiCss3/>
                  <SiJavascript/>
                  <DiMongodb />
                  <SiChakraui/>
                  <FaReact/>
                  
                </div>
                <div>
                  <a
                    href="https://everhour2.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/Jhakailash/Everhour"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
